import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosSolicitacaoExterna from "../../servicos/servicos-solicitacao-externa";
import servicosItemPedido from "../../servicos/servicos-item-pedido";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import Cancel from "../../img/svgs/Cancel";
import Delete from "../../img/svgs/Delete";
import Salvar from "../../img/svgs/Salvar";
import List from "../../img/svgs/List";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Edit from "../../img/svgs/Edit";

const ListSolicitacoesExternasPendentes = () => {
  const { user } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [editado, setEditado] = useState(false)
  const [deletado, setDeletado] = useState(false)
  const [show, setShow] = useState(false);
  const [showObservacao, setShowObservacao] = useState(false);
  const containerRef = useRef(null);
  const [solicitacao, setSolicitacao] = useState();
  const [entregue, setEntregue] = useState(false);
  const motivo_cancelamento = useRef();
  const [motivoVazio, setMotivoVazio] = useState(false);
  const [pedido, setPedido] = useState([]);
  const handleClose = () => setShow(false);
  const handleCloseObservacao = () => setShowObservacao(false);
  const [showDetalhes, setShowDetalhes] = useState(false);
  const handleCloseDetalhes = () => setShowDetalhes(false);
  const [itemsSelecionados, setItemsSelecionados] = useState([]);
  const observacao = useRef();

  useEffect(() => {
    function getDados() {
      servicosSolicitacaoExterna.listarSolicitacoesPendentes()
        .then(response => {
          if (response.status === 200) {
            setSolicitacoes(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [entregue, editado, deletado]);


  const cancelarSolicitacao = (motivo) => {
    if (motivo === "") {
      setMotivoVazio(true);
    } else {
      setEditado(false);
      const data = {
        "status": "cancelado",
        "responsavel": user.nome,
        "observacao": motivo
      }
      servicosSolicitacaoExterna.cancelarSolicitacao(solicitacao.id_solicitacao_externa, data).then(response => {
        if (response.status === 200) {
          setEditado(true);
        }
      })
      handleClose();
    }
  }

  const editarSolicitacao = () => {
    setEditado(false);
    const data = {
      "responsavel": user.nome,
      "observacao": observacao.current.value
    }
    servicosSolicitacaoExterna.editar(solicitacao.id_solicitacao_externa, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Observação adicionada");
      }
    }).catch(error => console.log(error));
    handleCloseObservacao();
  }

  const deletarSolicitacao = (id) => {
    let confirmacao = window.confirm("Você deseja realmente excluir a solicitação?");
    if (confirmacao === true) {
      setDeletado(false)
      servicosSolicitacaoExterna.deletar(id).then(response => {
        if (response.status === 200) {
          setDeletado(true);
          toast.success("A solicitação foi excluída com sucesso!", {
            theme: "colored",
          });
        }
      }).catch(error => {
        console.log(error);
        toast.error("Não foi possível excluir a solicitação!", {
          theme: "colored",
        });
      })
    }
  }


  const handleShow = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShow(true);
  }

  const handleShowObservacao = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShowObservacao(true);
  }


  const entrega = async (id) => {
    let confirmacao = window.confirm("Você deseja realmente entregar os produtos solicitados?");
    if (confirmacao === true) {
      const entrega = {
        "status": "finalizado",
        "data_entrega": new Date(),
        "responsavel": user.nome
      }
      servicosSolicitacaoExterna.editar(id, entrega)
        .then(response => {
          if (response.status === 200) {
            toast.success(`A solicitação nº ${id} foi entregue!`, {
              theme: "colored",
            });
            setEntregue(id);
            setShowDetalhes(false);
          }
        })
        .catch(e => {
          toast.error(`Falha na entrega da solicitação nº ${id}!`);
        })
    }
  }

  const entregaMultiplas = async () => {
    if (itemsSelecionados.length > 0) {
      let confirmacao = window.confirm("Você deseja realmente entregar os produtos solicitados?");
      if (confirmacao === true) {
        setEditado(false);
        for await (const i of itemsSelecionados) {
          const entregas = {
            "status": "finalizado",
            "data_entrega": new Date(),
            "responsavel": user.nome
          }
          servicosSolicitacaoExterna.editar(i, entregas)
            .then(response => {
              if (response.status === 200) {
                setEntregue(i);
              }
            })
            .catch(e => {
              console.log(e);
            })
        }
        toast.success("As solicitações foram entregues!", {
          theme: "colored",
        });
      }

    }

  }

  const handleShowDetalhes = (pedido) => {
    let id = pedido.id_solicitacao_externa;
    let listaItems = [];
    servicosItemPedido.listarUm(id).then(response => {
      if (response.status === 200) {
        listaItems = response.data;
        let item = {
          id: id,
          items: listaItems,
          pedido: pedido
        }

        setPedido(item);

        setShowDetalhes(true);
      }
    })

  }

  const columnsSolicitacoesExtPendentes = [
    {
      field: "detalhar",
      headerName: "",
      width: 90,
      renderCell: (params) => {
        return <button type="button" onClick={() => handleShowDetalhes(params.row)}><List /></button>
      }
    },
    { field: "id_solicitacao_externa", headerName: "ID", width: 45 },
    {
      field: "Colaborador[0].nome",
      headerName: "Solicitante",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.row.Colaborador[0].nome
      }
    },
    {
      field: "cdg_parceiro",
      headerName: "Cód. Agente",
      width: 150,
      editable: true
    },
    {
      field: "milhas_solicitacao",
      headerName: "Total",
      width: 150,
      editable: true
    },
    {
      field: "motivo_solicitacao",
      headerName: "Motivo",
      width: 150,
      editable: true
    },
    {
      field: "observacao",
      headerName: "Observação",
      width: 100,
      editable: true,
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        let aux = String(params.value).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    },
    {
      field: "editar",
      headerName: "Edit. Observação",
      width: 90,
      renderCell: (params) => {
        return <button size="sm" className="btn-icones p-1 rounded d-flex justify-content-center align-items-center" onClick={() => handleShowObservacao(params.row)}><Edit /> Editar</button>
      }
    },
    {
      field: "cancelar",
      headerName: "Cancelar",
      width: 100,
      renderCell: (params) => {
        return <button size="sm" className="btn-icones p-1 rounded " onClick={(e) => handleShow(params.row)}><Cancel /> Cancelar</button>
      }
    },
    {
      field: "excluir",
      headerName: "Excluir",
      width: 90,
      renderCell: (params) => {
        if (autorizado === true) {
          return <button className="btn-icones p-1 rounded" value={params.row.id_solicitacao} onClick={() => deletarSolicitacao(params.row.id_solicitacao_externa)}><Delete /> Excluir</button>
        } else {
          return ""
        }
      }
    }
  ];


  const ListaItemsPedido = (props) => {
    return <>
      {props.lista !== undefined && <div className="w-50 mt-4">
        <table className="lista-items-dados-solicitacao">
          <thead>
            <tr className="border">
              <th>Produto</th>
              <th>Tamanho</th>
              <th className="text-center">Qtd</th>
              <th className="text-center">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {props.lista.items.map(item => {
              return <tr key={item.id_produto} className="border">
                <td width={100}>{item.Produto[0].nome}</td>
                <td width={100}>{item.Produto[0]?.tamanho}</td>
                <td width={60} className="text-center">{item.qtd_produto}</td>
                <td className="text-center">{item.milhas}</td>
              </tr>
            })}
          </tbody>

        </table>
        <button className="btn-icones rounded p-1 mt-2" onClick={() => entrega(pedido.id)}>Entregar Pedido</button>
      </div>}
    </>
  }
  const ModalDetalhamentoPedido = () => {
    return <>

      <Modal className="modal-lg" show={showDetalhes} onHide={handleCloseDetalhes}>
        <Modal.Body className="modal-edica" >
          <div >
            <div className="d-flex justify-content-center">

              {
                pedido.pedido && <div>
                  <div className="info-solicitacao-externa p-1 d-flex justify-content-between">
                    <span style={{ fontSize: 18 }} className="ms-2">Dados Solicitação:</span>
                    <button style={{ width: 10 }} className=" p-1 rounded w-25" onClick={handleCloseDetalhes}>
                      <Cancel /> Voltar
                    </button>
                  </div>
                  <div className="dados-solicitacao-externa d-flex ">
                    <div className="w-50 mt-3 ms-2">
                      Pedido: <span className="font-weight-bold">{pedido.id}</span><br />
                      Código Agente: <span className="font-weight-bold">{pedido.pedido.cdg_parceiro}</span> <br />
                      Data Solicitação: <span className="font-weight-bold">{pedido.pedido.data_solicitacao}</span> <br />
                      Data Entrega: <span className="font-weight-bold">{pedido.pedido.data_entrega}</span> <br />
                      Total Solicitação:<span className="font-weight-bold">{pedido.pedido.milhas_solicitacao}</span>  <br />
                      Motivo Solicitação: <span className="font-weight-bold">{pedido.pedido.motivo_solicitacao}</span> <br />
                      Observação: <span className="font-weight-bold">{pedido.pedido.observacao}</span>  <br />
                      Responsável: <span className="font-weight-bold">{pedido.pedido.responsavel}</span> <br />
                      Status: <span className="font-weight-bold">{pedido.pedido.status}</span> <br />
                    </div>
                    <ListaItemsPedido lista={pedido} />
                  </div>

                  {/* {pedido.items[0]?.Produto[0].nome} */}

                </div>
              }


            </div>

          </div>

        </Modal.Body>

      </Modal>

    </>
  }
  const ModalEditar = () => {
    return <>
      <Modal className="" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  Você deseja realmente cancelar essa solicitação? <br />
                  <br></br>
                  Pedido: <strong>{solicitacao?.id_solicitacao_externa}</strong> <br />
                  {motivoVazio && <span className="errosValidacao">Por favor, nos informe o motivo do cancelamento.</span>}
                  <span>Motivo do cancelamento:</span>
                  <textarea ref={motivo_cancelamento} className="h-25" id="motivo_cancelamento">
                  </textarea>
                  <div className="text-center mt-4">
                    <button className="btn-icones p-1 rounded w-25 me-2" onClick={() => cancelarSolicitacao(motivo_cancelamento?.current?.value)} >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" variant="secondary" onClick={handleClose}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }
  const ModalObservacao = () => {
    return <>
      <Modal className="" show={showObservacao} onHide={handleCloseObservacao}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  Adicionar observação:
                  <textarea ref={observacao} defaultValue={solicitacao?.observacao} className="h-25" id="observacao">
                  </textarea>
                  <div className="text-center mt-4">
                    <button className="btn-icones p-1 rounded w-25 me-2" onClick={() => editarSolicitacao()} >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" variant="secondary" onClick={handleCloseObservacao}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }


  return (
    <>
      <NavMenu />
      <ModalDetalhamentoPedido />
      <ModalObservacao />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        {solicitacoes.length > 0 ? <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <h3 className="text-start subtitulo" style={{ fontSize: 20 }}>Solicitações Prod. Pendentes</h3>

          <Box sx={{ height: 650, width: 950, marginTop: 2 }}>
            <DataGrid
              checkboxSelection
              style={{ borderRadius: "20px" }}
              localeText={localizedTextsMap}
              rows={solicitacoes}
              columns={columnsSolicitacoesExtPendentes}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.id_solicitacao_externa}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
              onSelectionModelChange={itemsSelecionados => {
                setItemsSelecionados(itemsSelecionados);
              }}

            />
          </Box>



          <button className="p-1 ms-3 mt-3 rounded btn-esqueceu-senha border-0 text-light" onClick={entregaMultiplas}>Entregar solicitações selecionadas</button>
        </div> : <div className="ms-4 tabela mt-5">
          Por enquanto nenhuma solicitação por aqui!
        </div>}
      </div>
    </>
  );
};

export default ListSolicitacoesExternasPendentes;